import styled, { css } from 'styled-components';

import BREAKPOINTS from 'styles/breakpoints';
import COLORS from 'styles/colors';
import { fluidType, weight } from 'styles/typography';

const SIZES = {
  small: {
    avatar: {
      mobile: 43,
      desktop: 70,
    },
    border: {
      mobile: 1,
      desktop: 2,
    },
    fontSize: {
      mobile: 6,
      desktop: 10,
    },
  },
  medium: {
    avatar: {
      mobile: 70,
      desktop: 87,
    },
    border: {
      mobile: 3,
      desktop: 3,
    },
    fontSize: {
      mobile: 12,
      desktop: 12,
    },
  },
  large: {
    avatar: {
      mobile: 62,
      desktop: 100,
    },
    border: {
      mobile: 2,
      desktop: 3,
    },
    fontSize: {
      mobile: 10,
      desktop: 15,
    },
  },
};

const Container = styled.div`
  position: relative;
`;

const PlayerAvatar = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;
  border-radius: 50%;
  border-style: solid;
  border-color: ${COLORS.white};
  background: ${COLORS.forest}
    ${({ imgUrl }) => (imgUrl ? `url(${imgUrl})` : 'none')} no-repeat center;
  background-size: cover;

  ${({ size, fluidSize }) =>
    size &&
    !fluidSize &&
    css`
      width: ${SIZES[size].avatar.mobile}px;
      height: ${SIZES[size].avatar.mobile}px;
      border-width: ${SIZES[size].border.mobile}px;

      ${BREAKPOINTS.small`
        width: ${SIZES[size].avatar.desktop}px;
        height: ${SIZES[size].avatar.desktop}px;
        border-width: ${SIZES[size].border.desktop}px;
      `}
    `}

  ${({ size, fluidSize }) =>
    size &&
    fluidSize &&
    css`
      width: ${fluidType(
        SIZES[size].avatar.mobile,
        SIZES[size].avatar.desktop
      )};
      height: ${fluidType(
        SIZES[size].avatar.mobile,
        SIZES[size].avatar.desktop
      )};
      border-width: ${SIZES[size].border.mobile}px;

      ${BREAKPOINTS.medium`
        border-width: ${SIZES[size].border.desktop}px;
      `}
    `}

  ${({ medal }) =>
    medal &&
    css`
      border-color: ${COLORS[medal]};
    `}
`;

const Place = styled.div`
  display: flex;
  justify-content: center;
  background-color: ${({ medal }) => (medal ? COLORS[medal] : COLORS.white)};
  border-radius: 50%;
  border: 1px solid ${({ medal }) => (medal ? COLORS[medal] : COLORS.grey)};
  color: ${COLORS.forest};
  font-weight: ${weight.semibold};
  box-sizing: content-box;

  ${({ size, fluidSize }) =>
    size &&
    !fluidSize &&
    css`
      width: ${SIZES[size].avatar.mobile / 3}px;
      height: ${SIZES[size].avatar.mobile / 3}px;
      font-size: ${SIZES[size].fontSize.mobile}px;
      line-height: ${SIZES[size].avatar.mobile / 3}px;
      transform: translate(-35px, -20px);

      ${BREAKPOINTS.small`
        width: ${SIZES[size].avatar.desktop / 3}px;
        height: ${SIZES[size].avatar.desktop / 3}px;
        font-size: ${SIZES[size].fontSize.desktop}px;
        line-height: ${SIZES[size].avatar.desktop / 3}px;
        transform: translate(-42px,-24px);
      `}
    `}

  ${({ size, fluidSize }) =>
    size &&
    fluidSize &&
    css`
      width: ${fluidType(
        SIZES[size].avatar.mobile / 3,
        SIZES[size].avatar.desktop / 3
      )};
      height: ${fluidType(
        SIZES[size].avatar.mobile / 3,
        SIZES[size].avatar.desktop / 3
      )};
      font-size: ${fluidType(
        SIZES[size].fontSize.mobile,
        SIZES[size].fontSize.desktop
      )};
      line-height: ${fluidType(
        SIZES[size].avatar.mobile / 3,
        SIZES[size].avatar.desktop / 3
      )};
      transform: translateY(45%);
    `}
`;

const getMedal = (position) => {
  switch (position) {
    case '1':
      return 'gold';
    case '2':
      return 'silver';
    case '3':
      return 'bronze';
    default:
      return null;
  }
};

const Avatar = ({ imgUrl, size, fluidSize = true, position, className }) => {
  const medal = getMedal(position);
  return (
    <Container className={className}>
      <PlayerAvatar
        imgUrl={imgUrl}
        size={size}
        fluidSize={fluidSize}
        medal={medal}
      >
        <Place size={size} fluidSize={fluidSize} medal={medal}>
          {position}
        </Place>
      </PlayerAvatar>
    </Container>
  );
};

export default Avatar;
